import { ActivityDetails, ExtraCurricularActivityRequest } from './../../models/account/extra-curricular/extraCurricularRequest';
import { apiResponse } from './../../models/apiResponse';
import { CourseWorkRequest } from './../../models/account/coursework/courseworkRequest';
import { Observable } from 'rxjs';
import { GenericService } from './../generic.service';
import { Injectable } from '@angular/core';
import { DemoGraphyResponse } from '../../models/account/demographyResponse';
import { DemographyRequest } from '../../models/account/demographyRequest';
import { TestScoreRequest } from '../../models/account/test-score/testScoreRequest';
import { TestScoreResponse } from '../../models/account/test-score/testScoreResponse';
import { HighSchoolGradesResponse } from '../../models/account/grades/gradesResponse';
import { HighSchoolGradesRequest } from '../../models/account/grades/gradesRequest';
import { PageResponse } from '../../models/institute/randomInstituteResponse';
import { BoardsResponse } from '../../models/board/boardResponse';
import { CourseWorkResponse } from '../../models/account/coursework/courseWorkResponse';
import { Activity } from '../../models/account/extra-curricular/activity/activityResponse';
import { ExtraCurricularActivityResponse } from '../../models/account/extra-curricular/extraCurricularActivityResponse';
import { UserProfileStatus } from '../../models/account/userProfileStatus';
import { extraCurricularActivityDescriptionRequest } from '../../models/account/extra-curricular/activity/extraCurricularActivityDescriptionRequest';
import { TechnicalSkills, TechnicalSkillsRequest } from '../../models/account/extra-curricular/technicalSkillsRequest';
import { TechnicalSkillsResponse } from '../../models/account/extra-curricular/technicalSkillsResponse';
import { LicenseCertification, LicensesCertificationsRequest } from '../../models/account/extra-curricular/licensesCertificationsRequest';
import { LicensesCertificationsResponse } from '../../models/account/extra-curricular/licensesCertificationsResponse';

@Injectable({
  providedIn: 'root'
})
export class CompleteProfileService {

  constructor(private genericService: GenericService) { }

  getDemography(studentid?: string): Observable<DemoGraphyResponse> {
    return this.genericService.get(`demographics/${studentid}`)
  }

  updateDemography(demographyRequest: DemographyRequest): Observable<DemoGraphyResponse> {
    return this.genericService.put('demographics', demographyRequest);
  }

  getTestScore(studentId:string): Observable<TestScoreResponse> {
    return this.genericService.get(`testscore/${studentId}`);
  }

  updateTestScore(testScoreRequest: TestScoreRequest): Observable<TestScoreResponse> {
    return this.genericService.post('testscore', testScoreRequest);
  }

  getGrades(studentId: string): Observable<HighSchoolGradesResponse> {
    return this.genericService.get(`highschoolgrades/${studentId}`);
  }

  updateGrades(gradesRequest: HighSchoolGradesRequest): Observable<HighSchoolGradesResponse> {
    return this.genericService.put('highschoolgrades', gradesRequest);
  }

  getBoards(): Observable<PageResponse<BoardsResponse>> {
    return this.genericService.get('boards');
  }

  getCourseWork(studentId: string): Observable<CourseWorkResponse> {
    return this.genericService.get(`coursework/${studentId}`);
  }

  updateCourseWork(courseWorkRequest: CourseWorkRequest): Observable<CourseWorkResponse> {
    return this.genericService.post('coursework', courseWorkRequest);
  }

  getActivities(): Observable<apiResponse<Activity[]>> {
    return this.genericService.get('activities');
  }

  addExtraCurricular(extraCurricularActivityRequest: ExtraCurricularActivityRequest): Observable<ExtraCurricularActivityResponse> {
    return this.genericService.post('extracurricularactivity', extraCurricularActivityRequest.activityDetails);
  }

  updateExtraCurricularDescription(extraCurricularActivityDescriptionRequest: extraCurricularActivityDescriptionRequest): Observable<ExtraCurricularActivityResponse> {
    return this.genericService.put('extracurricularactivity', extraCurricularActivityDescriptionRequest);
  }

  getExtraCurricular(studentId:string): Observable<PageResponse<ActivityDetails>> {
    return this.genericService.get(`extracurricularactivity/${studentId}`);
  }

  getExtraCurricularById(id:string): Observable<ActivityDetails> {
    return this.genericService.get(`${id}/extracurricularactivity`);
  }

  getProfileStatus(studentId: string): Observable<UserProfileStatus> {
    return this.genericService.get(`user/profilestatus/${studentId}`);
  }
  addTechnicalSkills(req: TechnicalSkillsRequest):Observable<TechnicalSkillsResponse>
  {
    return this.genericService.post(`technicalskills`, req.technicalSkills);
  }
  getTechnicalSkills(studentid: string): Observable<PageResponse<TechnicalSkills>>
  {
    return this.genericService.get(`technicalskills/${studentid}`);
  }
  addLicensesCertifications(req: LicensesCertificationsRequest):Observable<LicensesCertificationsResponse>
  {
    return this.genericService.post(`licensescertifications`, req.licensesCertifications);
  }
  getLicensesCertifications(studentid: string): Observable<PageResponse<LicenseCertification>>
  {
    return this.genericService.get(`licensescertifications/${studentid}`);
  }
}
